import { createSlice } from "@reduxjs/toolkit";
import {
  getFaqSectionThunk,
  createFaqSectionThunk,
  updateFaqSectionThunk,
  deleteFaqSectionThunk,
} from "./FaqSectionThunk";

const initialState = {
  data: [],
  section: [],
  loading: false,
  status: "",
  message: "",
  type: "",
  language: "od",
  usertype: "fellow",
  sectionId: "",
  sectionName: "",
  disable_content_button: true,
};

const FaqSectionSlice = createSlice({
  name: "FaqSectionSlice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.section = [];
      state.sectionId = "";
      state.sectionName = "";
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.section = [];
      state.sectionId = "";
      state.sectionName = "";
      state.disable_content_button = true;
    },
  },
  extraReducers: {
    [getFaqSectionThunk.pending]: (state, action) => {
      state.section = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getFaqSectionThunk.fulfilled]: (state, action) => {
      state.section = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getFaqSectionThunk.rejected]: (state, action) => {
      state.section = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createFaqSectionThunk.pending]: (state, action) => {
      state.section = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createFaqSectionThunk.fulfilled]: (state, action) => {
      state.section = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createFaqSectionThunk.rejected]: (state, action) => {
      state.section = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [updateFaqSectionThunk.pending]: (state, action) => {
      state.section = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateFaqSectionThunk.fulfilled]: (state, action) => {
      state.section = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateFaqSectionThunk.rejected]: (state, action) => {
      state.section = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [deleteFaqSectionThunk.pending]: (state, action) => {
      state.section = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [deleteFaqSectionThunk.fulfilled]: (state, action) => {
      state.section = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [deleteFaqSectionThunk.rejected]: (state, action) => {
      state.section = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { language_change, usertype_change } = FaqSectionSlice.actions;

export default FaqSectionSlice.reducer;
